import { ref, computed, onMounted, onUnmounted } from 'vue';
import {
  isMobileScreenWidth,
  isNotMobileScreenWidth,
  isAtPWA,
} from 'dashboard/helper/zimobi/responsivenessHelper';

export function useResponsiveness() {
  const screenWidth = ref(window.innerWidth);

  const isAtMobile = computed(() => {
    return isMobileScreenWidth(screenWidth.value);
  });

  const isNotAtMobile = computed(() => {
    return isNotMobileScreenWidth(screenWidth.value);
  });

  const isAtMobilePWA = computed(() => {
    return isAtPWA() && isAtMobile.value;
  });

  const updateWidth = () => {
    screenWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', updateWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
  });

  return {
    isAtMobile,
    isNotAtMobile,
    isAtMobilePWA,
  };
}
